module.exports = __webpack_public_path__ + "static/media/anc3kz.b18babfa.pdf";